var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRepeatOnce = function SvgIconRepeatOnce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.043 3.043a1 1 0 0 1 1.414 0l2.25 2.25a1 1 0 0 1 0 1.414l-2.25 2.25a1 1 0 1 1-1.414-1.414L18.586 7H9A5.01 5.01 0 0 0 4 12.002a1 1 0 1 1-2-.004A7.01 7.01 0 0 1 8.998 5h9.588l-.543-.543a1 1 0 0 1 0-1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 8.9a1 1 0 0 1 .475.85v4.5a1 1 0 1 1-2 0v-2.882l-.053.026a1 1 0 1 1-.894-1.788l1.5-.75a1 1 0 0 1 .973.043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.002 11A1 1 0 0 1 22 12.002 7.01 7.01 0 0 1 15.002 19H5.414l.543.543a1 1 0 1 1-1.414 1.414l-2.25-2.25a1 1 0 0 1 0-1.414l2.25-2.25a1 1 0 0 1 1.414 1.414L5.414 17h9.584A5.01 5.01 0 0 0 20 11.998 1 1 0 0 1 21.002 11"
  }))));
};
export default SvgIconRepeatOnce;